import { combineReducers } from "redux";
import blogReducer from "./Blogs/reducer";
import filterReducer from "./filters/reducer";

const rootReducer = combineReducers({
    blogs: blogReducer,
    filters: filterReducer,
});

export default rootReducer;
